import React, { Suspense } from 'react';
import { Route, Routes, Navigate, useParams } from 'react-router-dom';

import { AboutFundPage } from './pages/AboutFundPage/AboutFundPage';

import Header from './components/Header/Header';
import InfoArtistModal from './components/InfoArtistModal/InfoArtistModal';
import Form from './components/Form/Form';
import Categories from './components/Header/Categories/Categories';
import AdditionalMenu from './components/AdditionalMenu/AdditionalMenu';
import { CategoryDetails } from './components/Header/Categories/CategoryDetails/CategoryDetails';

import { useCurrentRoute } from './hooks/useCurrentRoute';
import { useCategories } from './hooks/useCategories';
import { useFilters } from './hooks/useFilters';

import { useArtistModalStore } from './stores/artistModalStore';
import { useFormModal } from './stores/formStore';
import MetaHelmet from './components/SeoManager/SeoManager';

const AllContentList = React.lazy(
  () => import('./components/AllContent/AllContentList/AllContentList')
);
const DetailsPage = React.lazy(() => import('./pages/DetailsPage/DetailsPage'));
const AboutProjectPage = React.lazy(
  () => import('./pages/AboutProjectPage/AboutProjectPage')
);
const ZapovitPage = React.lazy(() => import('./pages/ZapovitPage/Zapovit'));

const DetailsPageWrapper: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return <DetailsPage slug={slug} />;
};


const AboutProjectPageWrapper: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  return <AboutProjectPage slug={slug} />;
};

const App: React.FC = () => {
  const { isOpen, currentSlug } = useArtistModalStore();
  const { isAllContentList } = useCurrentRoute();
  const { isOpen: isFormOpen } = useFormModal();
  const { data: categoriesData } = useCategories();
  const { selectedCategory } = useFilters();

  const isCategoryPage = categoriesData?.categories.some(
    (category) => `/${category.slug}` === location.pathname
  );



  return (
    <div className="container">
        <MetaHelmet  />
      <Header />
      <Categories />
      {selectedCategory && isCategoryPage && <CategoryDetails />}

      
      
      {isAllContentList && <AdditionalMenu />}
      {isFormOpen && <Form />}
      {isOpen && currentSlug && <InfoArtistModal slug={currentSlug} />}
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route
            path="/"
            element={<AllContentList isCategoryPage={isCategoryPage} />}
          />
          <Route
            path="/:categorySlug"
            element={<AllContentList isCategoryPage={isCategoryPage} />}
          />
          <Route path="/legal/zapovit" element={<ZapovitPage />} />
          <Route path="/:categorySlug/:slug" element={<DetailsPageWrapper />} />
          <Route
            path="/about_project/:categorySlug/:slug"
            element={<AboutProjectPageWrapper />}
          />
          <Route path="/about-fund" element={<AboutFundPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;

